<template>
    <div>
        <!-- <Video /> -->
        <Monitor />
        <Events />
        <!-- 设备状态 -->
        <DeviceStatus  />
        
        <!-- 楼层人员监测 -->
        <FloorDetection v-if="selectBuildId !=''" />  
        <!-- 楼宇安防评分 -->
        <SecurityScore  v-else/>  
        
        <!-- 人员巡查动态 -->
        <Inspection  />
        <!-- 人员密集度统计 -->
        <StaffDensity  />

    </div>
</template>

<script>
    const Monitor = () => import("../../components/Monitor")
    const Video = () => import("../../components/Video")
    const Events = () => import("../../components/Events")
  
    const DeviceStatus = () => import("./components/DeviceStatus.vue")
    const Inspection = () => import("./components/Inspection.vue")
    const StaffDensity = () => import("./components/StaffDensity.vue")
    const SecurityScore = () => import("./components/SecurityScore.vue")
    const FloorDetection = () => import("./components/FloorDetection.vue")


    export default {
        name: "security",
        props:{
            selectBuildId:String
        },
        components: {
            Monitor,
            Events,
            DeviceStatus,
            Inspection,
            StaffDensity,
            SecurityScore,
            FloorDetection,
            Video
        },
        data() {
            return {
            };
        }
    };
</script>

<style lang="less" scoped>
  
</style>